import RedeemedMNCLayout from "./RedeemedMNCLayout";
import RedeemedVoucherReportPage from "./pages/RedeemedVoucherReportPage.vue";
import HomeDiscountVoucherReportPage from "./pages/HomeDiscountVoucherReportPage.vue";

export const RedeemedMNCPathRoutes = (prefix = "") => [
  {
    name: "RedeemedVoucherReportPage",
    path: "redeemed-voucher-report",
    component: RedeemedVoucherReportPage
  },
  {
    name: "HomeDiscountVoucherReportPage",
    path: "home-discount-voucher-report",
    component: HomeDiscountVoucherReportPage
  }
];

export const redeemedMNCRoutes = {
  path: "redeemed-mnc",
  component: RedeemedMNCLayout,
  children: [
    ...RedeemedMNCPathRoutes()
  ]
};



// WEBPACK FOOTER //
// ./src/features/redeemed-mnc/routes.js